import { render, staticRenderFns } from "./AvailableCustomers.vue?vue&type=template&id=2b412d0c"
import script from "./AvailableCustomers.vue?vue&type=script&lang=js"
export * from "./AvailableCustomers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports